import { types as updateStatusTypes } from './waiverWorkItemUpdateStatusActions';
import { fetchWaiverWorkItemDetails } from '../../../entities/waivers/workItems/WaiverWorkItemDetailsActions';
import { fetchWaivers } from '../../../entities/waivers/waivers/waiversActions';
import {
  updateWaiverWorkItem as entityUpdateWaiverWorkItem,
  snoozeNotificationsForAirline as entitySnoozeNotificationsForAirline,
} from '../../../entities/waivers/workItems/WaiverWorkItemDetailsActions';
import { ThunkAction, Dispatch } from '../../../types';
import {
  WaiverWorkItem,
  WaiverWorkItemAction,
} from '../../../../types/waiverWorkItem';

export const loadComponent = (workItemId: number) => {
  return (dispatch: Dispatch) =>
    Promise.all([
      dispatch({ type: updateStatusTypes.RESET }),
      dispatch(fetchWaiverWorkItemDetails(workItemId)),
      dispatch(fetchWaivers()),
    ]);
};

export const updateWaiverWorkItem = (waiverWorkItem: WaiverWorkItem): ThunkAction =>
  executeActionWithChangeNotification(
    dispatch => dispatch(entityUpdateWaiverWorkItem(waiverWorkItem)),
    'Update successful!',
  );

export const snoozeNotificationsForAirline = (airlineCode: string, hoursToSnooze: number): ThunkAction =>
  executeActionWithChangeNotification(
    dispatch =>
      dispatch(entitySnoozeNotificationsForAirline(airlineCode, hoursToSnooze)),
    `Snoozed successfully for ${hoursToSnooze} hours.`,
  );

export const executeWaiverWorkItemAction = (
  action: WaiverWorkItemAction,
  workItem: WaiverWorkItem,
): ThunkAction =>
  executeActionWithChangeNotification(
    dispatch => action.action(dispatch, workItem),
    action.executeSuccessMessage,
    action.executeErrorMessage,
  );

const executeActionWithChangeNotification = (
  executeAction: (dispatch: Dispatch) => Promise<any>,
  successMessage?: string,
  errorMessage?: string,
): ThunkAction => {
  return (dispatch: Dispatch) => {
    dispatch({ type: updateStatusTypes.CHANGE });
    executeAction(dispatch).then(
      () =>
        dispatch({
          type: updateStatusTypes.CHANGE_SUCCESS,
          response: successMessage,
        }),
      error =>
        dispatch({
          type: updateStatusTypes.CHANGE_FAIL,
          response: errorMessage || error,
        }),
    );
  };
};
